//© 2025 Kaitlyn Troxell
import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

function AddUserModal({ setShowAddUser }) {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    role: "homeowner" // default to homeowner
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email.trim()) {
      setError("Email is required");
      return;
    }
    if (!formData.password.trim()) {
      setError("Password is required");
      return;
    }

    setSaving(true);
    setError("");

    try {
      // Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        formData.email, 
        formData.password
      );
      
      // Create corresponding Firestore document with role
      await setDoc(doc(db, 'users', userCredential.user.uid), {
        email: formData.email,
        active: true,
        role: formData.role,
        createdAt: new Date()
      });
      
      alert("User added successfully!");
      setShowAddUser(false);
    } catch (err) {
      console.error("Error adding user:", err);
      setError(err.message || "Failed to add user");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-container add-user-modal">
        <h3 className="modal-title">Add New User</h3>

        {error && <div className="form-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              placeholder="user@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              Password <span className="required">*</span>
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter a password (min 6 characters)"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="role">
              User Role <span className="required">*</span>
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="homeowner">Homeowner (View Only)</option>
              <option value="admin">Admin (Full Access)</option>
            </select>
            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
              Homeowners can only view the calendar. Admins have full access.
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={() => setShowAddUser(false)}
              className="modal-cancel-btn"
              disabled={saving}
            >
              Cancel
            </button>

            <button type="submit" className="save-btn" disabled={saving}>
              {saving ? "Adding..." : "Add User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddUserModal;